import { render, staticRenderFns } from "./index.vue?vue&type=template&id=476960f9&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=476960f9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476960f9",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Author: require('/var/jenkins_home/workspace/prod-web-xfans/components/author.vue').default})
